// PokeApp-Kevin Simon

import React, { useState, useEffect } from 'react'; //import react and hooks

function App() {
  const [pokemon, setPokemon] = useState(null); // initialize pokemon state and setup setPokemon to update it if things are working
  const [loading, setLoading] = useState(true); // or this if loading
  const [error, setError] = useState(false); // or this if broken - doesn't seem to do anything

// hook used every time browser is refreshed 

  useEffect(() => { 
    const randomId = Math.floor(Math.random() * 898) + 1;  // generate a random pokemon number from 1-899
    const apiUrl = `https://pokeapi.co/api/v2/pokemon/${randomId}`; // set constant url for API location

// fetch method used to get the info for the specific pokemon

    fetch(apiUrl)  
      .then(response => response.json())
      .then(async data => {
        const speciesUrl = `https://pokeapi.co/api/v2/pokemon-species/${randomId}/?language=en`; // tried using different url to keep descriptions in english. some are still in other languages though
        const speciesResponse = await fetch(speciesUrl); 
        const speciesData = await speciesResponse.json(); // get species info and description
        setPokemon({ ...data, description: speciesData. // update state with info
        flavor_text_entries[0].flavor_text });
        setLoading(false); // set the loading state as false once everything loads up
      })  
  }, []);

// loading and error reporting though im not sure the error reporting actually works

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>There was an error loading the data.</div>;
  } 

// Basic HTML to display info with a little bit of css to try to make it look nice
// "pokename" just underlines the name and "zoom" does a cool little zoom in on the picture of the pokemon when hovered over

  return (
    <div>
      <h1 class="pokename">{pokemon.name}</h1>  
      <p class="zoom"><img src={pokemon.sprites. front_default} alt={pokemon.name} /></p>
      <p>Hover over picture to enlarge</p>
      <p>Type: {pokemon.types[0].type.name}</p>
      <p>Weight: {pokemon.weight / 10} kg</p>
      <p>Height: {pokemon.height / 10} m</p>
      <p>Description: {pokemon.description}</p>
    </div>
  );
}
// export the output to app.js

export default App;
